import { gql } from '@apollo/client';
import React from 'react';
import { Link } from '../utils/router/v3Bridge';
import type { ActivityThankedPost_ActivityFragment } from '../graphql/generated/graphqlTypes';
import ActivityPostCard from './ActivityPostCard';
import userPath from '../utils/url/userPath';
import activitiesPostTopics from './activitiesPostTopics';
import Activity from './Activity';

const ACTIVITY_THANKED_POST_ACTIVITY = gql`
  fragment ActivityThankedPost_activity on ThankedPostActivity {
    actedAt
    actor {
      id
      name
      ...Activity_actor
      ...userPath_user
    }
    thankedPost {
      id
      topics {
        ...activitiesPostTopics_topics
      }
      owner {
        name
        ...userPath_user
      }
      ...ActivityPostCard_post
    }
  }
  ${activitiesPostTopics.fragments.topics}
  ${ActivityPostCard.fragments.post}
  ${Activity.fragments.actor}
  ${userPath.fragments.user}
`;

interface ActivityThankedPostProps {
  activity: ActivityThankedPost_ActivityFragment;
}

const ActivityThankedPost = ({ activity }: ActivityThankedPostProps) => {
  const { actor, actedAt, thankedPost } = activity;

  if (!actor) {
    return null;
  }

  return (
    <Activity
      actor={actor}
      actedAt={actedAt}
      action="POST_THANK"
      title={
        <>
          <Link to={userPath(actor)}>{actor?.name}</Link> thanked
          {thankedPost?.owner && (
            <>
              {' '}
              <Link to={userPath(thankedPost?.owner)}>
                {thankedPost?.owner?.name}
              </Link>{' '}
              for
            </>
          )}{' '}
          a post
        </>
      }
      meta={activitiesPostTopics(thankedPost?.topics)}
    >
      {thankedPost ? (
        <ActivityPostCard post={thankedPost} numLines={4} charsPerLine={30} />
      ) : null}
    </Activity>
  );
};

ActivityThankedPost.fragments = {
  activity: ACTIVITY_THANKED_POST_ACTIVITY,
};

export default ActivityThankedPost;
